import { render } from "./MenuViewer.vue?vue&type=template&id=761933bd&scoped=true"
import script from "./MenuViewer.vue?vue&type=script&lang=js"
export * from "./MenuViewer.vue?vue&type=script&lang=js"

import "./MenuViewer.vue?vue&type=style&index=0&id=761933bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761933bd"]])

export default __exports__